import React from "react";
import { cn } from "utils";
import { ospThemes } from "@ospweb/sdk-ui";
interface GradientProgressBarProps {
  /** 当前值 (0-100) */
  value: number;
  /** 起始颜色 */
  startColor?: string;
  /** 结束颜色 */
  endColor?: string;
  /** 进度条高度 */
  height?: number;
  /** 进度条圆角 */
  borderRadius?: number;
  /** 滑块大小 */
  sliderSize?: number;
  /** 滑块边框宽度 */
  sliderBorderWidth?: number;
  /** 滑块边框颜色 */
  sliderBorderColor?: string;
  /** 是否显示滑块 */
  showSlider?: boolean;
  /** 自定义类名 */
  className?: string;
}

export const GradientProgressBar: React.FC<GradientProgressBarProps> = ({
  value,
  startColor = "#F7931A",
  endColor = "#1ED1E9",
  height = 8,
  borderRadius = 4,
  sliderSize = 14,
  sliderBorderWidth = 3,
  sliderBorderColor = ospThemes.colors.background_solid_neutral_primary,
  showSlider = true,
  className,
}) => {
  // 限制值在 0-100 范围内
  const normalizedValue = Math.min(Math.max(value, 0), 100);

  // 计算滑块位置（Safari 兼容版本）
  // 原理：滑块位置 = normalizedValue% - (normalizedValue * sliderSize / 100)px + (sliderSize / 2)px
  // 这样可以确保滑块在 0% 时从左边界开始，100% 时到达右边界
  const offsetPx = (normalizedValue * sliderSize) / 100 - sliderSize / 2;
  const sliderPosition = `calc(${normalizedValue}% - ${offsetPx}px)`;

  return (
    <div
      className={cn("relative w-full", className)}
      style={{
        height: `${height}px`,
      }}
    >
      {/* 渐变背景条 - 占满整个宽度 */}
      <div
        className="w-full h-full"
        style={{
          background: `linear-gradient(90deg, ${startColor} 0%, ${endColor} 100%)`,
          borderRadius: `${borderRadius}px`,
        }}
      />

      {/* 滑块 */}
      {showSlider && (
        <div
          className="absolute top-1/2 -translate-y-1/2 rounded-full bg-background_solid_quaternary"
          style={{
            left: sliderPosition,
            transform: "translate(-50%, -50%)",
            width: `${sliderSize}px`,
            height: `${sliderSize}px`,
            border: `${sliderBorderWidth}px solid ${sliderBorderColor}`,
          }}
        />
      )}
    </div>
  );
};
